import React, { useState, useRef } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import whyChooseImg from './images/why-choose.png';

const FEATURES_DATA = [
  {
    title: "Verified creators",
    desc: "Every creator on the platform passes identity checks before joining"
  },
  {
    title: "Meaningful interactions",
    desc: "Conversations designed for genuine connection, not scripted engagement"
  },
  {
    title: "Private communication",
    desc: "Your messages stay between you and the creator — never shared or sold"
  },
  {
    title: "Secure platform",
    desc: "Payments and messages are protected end-to-end, at every step"
  },
  {
    title: "Premium member experience",
    desc: "A curated, ad-free environment built entirely around member quality"
  }
];

const renderFeatureIcon = (index: number, prefix: string) => {
  switch (index) {
    case 0:
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke={`url(#${prefix}_paint0_11563_12288)`} />
          <path d="M36.5629 25.7386L35.2029 24.1586C34.9429 23.8586 34.7329 23.2986 34.7329 22.8986V21.1986C34.7329 20.1386 33.8629 19.2686 32.8029 19.2686H31.1029C30.7129 19.2686 30.1429 19.0586 29.8429 18.7986L28.2629 17.4386C27.5729 16.8486 26.4429 16.8486 25.7429 17.4386L24.1728 18.8086C23.8728 19.0586 23.3028 19.2686 22.9128 19.2686H21.1828C20.1228 19.2686 19.2528 20.1386 19.2528 21.1986V22.9086C19.2528 23.2986 19.0428 23.8586 18.7928 24.1586L17.4428 25.7486C16.8628 26.4386 16.8628 27.5586 17.4428 28.2486L18.7928 29.8386C19.0428 30.1386 19.2528 30.6986 19.2528 31.0886V32.7986C19.2528 33.8586 20.1228 34.7286 21.1828 34.7286H22.9128C23.3028 34.7286 23.8728 34.9386 24.1728 35.1986L25.7529 36.5586C26.4429 37.1486 27.5729 37.1486 28.2729 36.5586L29.8529 35.1986C30.1529 34.9386 30.7129 34.7286 31.1129 34.7286H32.8129C33.8729 34.7286 34.7429 33.8586 34.7429 32.7986V31.0986C34.7429 30.7086 34.9529 30.1386 35.2129 29.8386L36.5729 28.2586C37.1529 27.5686 37.1529 26.4286 36.5629 25.7386ZM31.1629 25.1086L26.3329 29.9386C26.1929 30.0786 26.0029 30.1586 25.8029 30.1586C25.6029 30.1586 25.4129 30.0786 25.2729 29.9386L22.8528 27.5186C22.5628 27.2286 22.5628 26.7486 22.8528 26.4586C23.1428 26.1686 23.6228 26.1686 23.9128 26.4586L25.8029 28.3486L30.1029 24.0486C30.3929 23.7586 30.8729 23.7586 31.1629 24.0486C31.4529 24.3386 31.4529 24.8186 31.1629 25.1086Z" fill={`url(#${prefix}_paint1_11563_12288)`} />
          <defs>
            <linearGradient id={`${prefix}_paint0_11563_12288`} x1="0" y1="27" x2="54" y2="27" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint1_11563_12288`} x1="17.0078" y1="26.9986" x2="37.0066" y2="26.9986" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 1:
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke={`url(#${prefix}_paint0_11563_12296)`} />
          <path d="M36.4219 24.2969H31.6406V25.1811C31.6406 26.1638 31.2823 27.0639 30.6904 27.7593H34.6964C35.0847 27.7593 35.3995 28.0742 35.3995 28.4625C35.3995 28.8508 35.0847 29.1656 34.6964 29.1656L23.7656 29.1655V32.8625C23.7656 34.2841 24.9222 35.4406 26.3438 35.4406H32.4214L35.7082 37.2929C35.8154 37.3533 35.9344 37.3834 36.0534 37.3834C36.176 37.3834 36.2986 37.3514 36.4081 37.2874C36.6239 37.1613 36.7565 36.9302 36.7565 36.6803V35.419C38.0205 35.2544 39 34.1707 39 32.8625V26.875C39 25.4534 37.8435 24.2969 36.4219 24.2969ZM28.0693 30.5718H34.6965C35.0848 30.5718 35.3996 30.8867 35.3996 31.275C35.3996 31.6633 35.0848 31.9781 34.6965 31.9781H28.0693C27.681 31.9781 27.3661 31.6633 27.3661 31.275C27.3661 30.8867 27.6809 30.5718 28.0693 30.5718Z" fill={`url(#${prefix}_paint1_11563_12296)`} />
          <path d="M18.2918 29.6112L21.5786 27.759H27.6562C29.0778 27.759 30.2344 26.6024 30.2344 25.1808V19.1934C30.2344 17.7718 29.0778 16.6152 27.6562 16.6152H17.5781C16.1565 16.6152 15 17.7718 15 19.1934V25.1808C15 26.489 15.9795 27.5727 17.2435 27.7373V28.9987C17.2435 29.2486 17.3761 29.4797 17.5919 29.6057C17.7014 29.6697 17.824 29.7018 17.9466 29.7018C18.0656 29.7018 18.1846 29.6716 18.2918 29.6112ZM19.3036 20.0777H25.9308C26.3191 20.0777 26.634 20.3925 26.634 20.7808C26.634 21.1691 26.3191 21.484 25.9308 21.484H19.3036C18.9153 21.484 18.6005 21.1691 18.6005 20.7808C18.6005 20.3925 18.9153 20.0777 19.3036 20.0777ZM19.3036 22.8902H25.9308C26.3191 22.8902 26.634 23.205 26.634 23.5933C26.634 23.9816 26.3191 24.2965 25.9308 24.2965H19.3036C18.9153 24.2965 18.6005 23.9816 18.6005 23.5933C18.6005 23.205 18.9153 22.8902 19.3036 22.8902Z" fill={`url(#${prefix}_paint2_11563_12296)`} />
          <defs>
            <linearGradient id={`${prefix}_paint0_11563_12296`} x1="0" y1="27" x2="54" y2="27" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint1_11563_12296`} x1="23.7656" y1="30.8402" x2="39" y2="30.8402" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint2_11563_12296`} x1="15" y1="23.1585" x2="30.2344" y2="23.1585" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 2:
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke={`url(#${prefix}_paint0_11563_12306)`} />
          <path d="M33.7226 23.4939C32.7426 23.4939 31.9426 24.2939 31.9426 25.2739V28.7439C31.9426 29.7239 32.7426 30.5239 33.7226 30.5239C34.7026 30.5239 35.5026 29.7239 35.5026 28.7439V25.2739C35.5026 24.2939 34.7026 23.4939 33.7226 23.4939Z" fill={`url(#${prefix}_paint1_11563_12306)`} />
          <path d="M29.5828 20.4485C27.9128 18.7785 25.6228 17.8086 23.1528 17.8086C18.1728 17.8086 14.1328 21.8486 14.1328 26.8286C14.1328 28.7486 14.7328 30.5886 15.8628 32.1386L14.7828 35.3786C14.6328 35.8386 14.7528 36.3386 15.0928 36.6786C15.3328 36.9186 15.6628 37.0486 16.0028 37.0486C16.1428 37.0486 16.2928 37.0186 16.4328 36.9686L19.9828 35.7886C20.9828 36.3186 22.0628 36.6286 23.1528 36.6286C23.7028 36.6286 24.1528 36.1786 24.1528 35.6286C24.1528 35.0786 23.7028 34.6286 23.1528 34.6286C22.2028 34.6286 21.2528 34.3586 20.3828 33.8986C20.1228 33.7586 19.8228 33.7386 19.5428 33.8286L16.9928 34.6786L17.7728 32.3386C17.9128 31.9186 17.7928 31.4586 17.4728 31.1486C16.6028 30.2986 16.1328 28.5986 16.1328 26.8286C16.1328 22.9586 19.2828 19.8086 23.1528 19.8086C25.0828 19.8086 26.8628 20.5686 28.1628 21.8685C28.5528 22.2585 29.1928 22.2585 29.5828 21.8685C29.9728 21.4785 29.9728 20.8385 29.5828 20.4485Z" fill={`url(#${prefix}_paint2_11563_12306)`} />
          <path d="M38.8633 26.6992H38.5033V25.2692C38.5033 22.6392 36.3633 20.4992 33.7333 20.4992C31.1033 20.4992 28.9633 22.6392 28.9633 25.2692V26.6992H28.5933C27.2833 26.6992 26.2233 27.7592 26.2233 29.0692V33.8292C26.2233 35.1392 27.2833 36.1992 28.5933 36.1992H38.8633C40.1733 36.1992 41.2333 35.1392 41.2333 33.8292V29.0692C41.2333 27.7592 40.1733 26.6992 38.8633 26.6992ZM30.9633 25.2692C30.9633 23.7492 32.2033 22.4992 33.7333 22.4992C35.2633 22.4992 36.5033 23.7492 36.5033 25.2692V26.6992H30.9633V25.2692ZM39.2333 33.8292C39.2333 34.0292 39.0633 34.1992 38.8633 34.1992H28.5933C28.3933 34.1992 28.2233 34.0292 28.2233 33.8292V29.0692C28.2233 28.8692 28.3933 28.6992 28.5933 28.6992H38.8633C39.0633 28.6992 39.2333 28.8692 39.2333 29.0692V33.8292Z" fill={`url(#${prefix}_paint3_11563_12306)`} />
          <defs>
            <linearGradient id={`${prefix}_paint0_11563_12306`} x1="0" y1="27" x2="54" y2="27" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint1_11563_12306`} x1="31.9426" y1="27.0089" x2="35.5026" y2="27.0089" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint2_11563_12306`} x1="14.1328" y1="27.4286" x2="29.8735" y2="27.4286" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint3_11563_12306`} x1="26.2233" y1="28.3492" x2="41.2333" y2="28.3492" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 3:
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke={`url(#${prefix}_paint0_11563_12316)`} />
          <path d="M33.0033 22.0494C32.6133 22.0494 32.2233 21.8994 31.9333 21.6094C30.6833 20.3594 28.9833 19.4694 27.0033 19.4694C25.0233 19.4694 23.3233 20.3594 22.0733 21.6094C21.4833 22.1994 20.5333 22.1994 19.9533 21.6094C19.3633 21.0194 19.3633 20.0694 19.9533 19.4894C21.6733 17.7694 24.1633 16.4694 27.0033 16.4694C29.8433 16.4694 32.3333 17.7694 34.0533 19.4894C34.6433 20.0794 34.6433 21.0294 34.0533 21.6094C33.7733 21.9094 33.3833 22.0494 33.0033 22.0494Z" fill={`url(#${prefix}_paint1_11563_12316)`} />
          <path d="M27.0033 38.0805C23.0033 38.0805 16.5033 34.3305 16.5033 26.5805V24.5705C16.5033 24.0205 16.9533 23.5705 17.5033 23.5705C18.0533 23.5705 18.5033 24.0205 18.5033 24.5705V26.5805C18.5033 32.8805 23.8533 36.0805 27.0033 36.0805C30.1533 36.0805 35.5033 32.8805 35.5033 26.5805V24.5705C35.5033 24.0205 35.9533 23.5705 36.5033 23.5705C37.0533 23.5705 37.5033 24.0205 37.5033 24.5705V26.5805C37.5033 34.3305 31.0033 38.0805 27.0033 38.0805Z" fill={`url(#${prefix}_paint2_11563_12316)`} />
          <path d="M26.9961 33.7291C23.2761 33.7291 20.2561 30.7091 20.2561 26.9891C20.2561 23.2691 23.2761 20.2491 26.9961 20.2491C30.7161 20.2491 33.7361 23.2691 33.7361 26.9891C33.7361 30.7091 30.7161 33.7291 26.9961 33.7291ZM26.9961 22.2491C24.3861 22.2491 22.2561 24.3791 22.2561 26.9891C22.2561 29.5991 24.3861 31.7291 26.9961 31.7291C29.6061 31.7291 31.7361 29.5991 31.7361 26.9891C31.7361 24.3791 29.6061 22.2491 26.9961 22.2491Z" fill={`url(#${prefix}_paint3_11563_12316)`} />
          <path d="M27.0039 30.4199C25.1139 30.4199 23.5739 28.8799 23.5739 26.9899C23.5739 25.0999 25.1139 23.5599 27.0039 23.5599C28.8939 23.5599 30.4339 25.0999 30.4339 26.9899C30.4339 28.8799 28.8939 30.4199 27.0039 30.4199ZM27.0039 25.5599C26.2139 25.5599 25.5739 26.1999 25.5739 26.9899C25.5739 27.7799 26.2139 28.4199 27.0039 28.4199C27.7939 28.4199 28.4339 27.7799 28.4339 26.9899C28.4339 26.1999 27.7939 25.5599 27.0039 25.5599Z" fill={`url(#${prefix}_paint4_11563_12316)`} />
          <defs>
            <linearGradient id={`${prefix}_paint0_11563_12316`} x1="0" y1="27" x2="54" y2="27" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint1_11563_12316`} x1="19.3672" y1="19.2594" x2="34.6394" y2="19.2594" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint2_11563_12316`} x1="16.5033" y1="30.8255" x2="37.5033" y2="30.8255" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint3_11563_12316`} x1="20.2561" y1="26.9891" x2="33.7361" y2="26.9891" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint4_11563_12316`} x1="23.5739" y1="26.9899" x2="30.4339" y2="26.9899" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 4:
      return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="53" height="53" rx="26.5" stroke={`url(#${prefix}_paint0_11563_12328)`} />
          <path d="M37.5 28.5801H16.5C15.67 28.5801 15 27.9101 15 27.0801C15 26.2501 15.67 25.5801 16.5 25.5801H37.5C38.33 25.5801 39 26.2501 39 27.0801C39 27.9101 38.33 28.5801 37.5 28.5801Z" fill={`url(#${prefix}_paint1_11563_12328)`} />
          <path d="M27 39.0801C26.17 39.0801 25.5 38.4101 25.5 37.5801V16.5801C25.5 15.7501 26.17 15.0801 27 15.0801C27.83 15.0801 28.5 15.7501 28.5 16.5801V37.5801C28.5 38.4101 27.83 39.0801 27 39.0801Z" fill={`url(#${prefix}_paint2_11563_12328)`} />
          <path d="M34.42 35.0001C34.04 35.0001 33.65 34.8501 33.36 34.5601L19.56 20.7601C18.97 20.1701 18.97 19.2201 19.56 18.6401C20.15 18.0501 21.1 18.0501 21.68 18.6401L35.48 32.4401C36.07 33.0301 36.07 33.9801 35.48 34.5601C35.2 34.8501 34.81 35.0001 34.42 35.0001Z" fill={`url(#${prefix}_paint3_11563_12328)`} />
          <path d="M19.58 35.0001C19.19 35.0001 18.81 34.8501 18.52 34.5601C17.93 33.9701 17.93 33.0201 18.52 32.4401L32.32 18.6401C32.91 18.0501 33.86 18.0501 34.44 18.6401C35.03 19.2301 35.03 20.1801 34.44 20.7601L20.64 34.5601C20.35 34.8501 19.96 35.0001 19.58 35.0001Z" fill={`url(#${prefix}_paint4_11563_12328)`} />
          <defs>
            <linearGradient id={`${prefix}_paint0_11563_12328`} x1="0" y1="27" x2="54" y2="27" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint1_11563_12328`} x1="15" y1="27.0801" x2="39" y2="27.0801" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint2_11563_12328`} x1="25.5" y1="27.0801" x2="28.5" y2="27.0801" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint3_11563_12328`} x1="19.1211" y1="26.6001" x2="35.9189" y2="26.6001" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
            <linearGradient id={`${prefix}_paint4_11563_12328`} x1="18.0811" y1="26.6001" x2="34.8789" y2="26.6001" gradientUnits="userSpaceOnUse">
              <stop stopColor="#CF819D" />
              <stop offset="0.438776" stopColor="#FFB8D1" />
              <stop offset="1" stopColor="#CF819D" />
            </linearGradient>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

const useStyles = makeStyles((theme) => ({
  whyMembersOuter: {
    backgroundColor: '#0a0a0a',
    padding: '80px 0',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0',
    },
  },
  whyMembersSection: {
    maxWidth: 1314,
    margin: '0 auto',
    padding: '0 0px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '60px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '40px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: 0,
      padding: '0 20px',
    },
  },
  mobileHeader: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
      marginBottom: '24px',
    },
  },
  desktopHeader: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  whyImageContainer: {
    flex: 1,
    maxWidth: '580px',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      maxWidth: '520px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginBottom: '30px',
    },
  },
  whyImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    borderRadius: '20px',
    display: 'block',
    boxShadow: '0 12px 36px rgba(0, 0, 0, 0.5)',
  },
  whyContent: {
    flex: 1,
    maxWidth: '642px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  whyTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: '0%',
    color: '#ffffff',
    margin: '0 0 16px 0',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      textAlign: 'center',
      marginBottom: '12px',
    },
  },
  whySubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 200,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '0%',
    color: '#ffffff',
    margin: '0 0 32px 0',
    textAlign: 'left',
    maxWidth: '580px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'center',
      marginBottom: '12px',
    },
  },
  featuresList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '642px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    background: 'transparent',
    width: '100%',
    boxSizing: 'border-box',
    padding: 0,
    '&:not(:last-child)': {
      paddingBottom: '12px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
  featureIconWrapper: {
    width: 54,
    height: 54,
    minWidth: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  featureTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    gap: '4px',
  },
  featureTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '24px',
    fontWeight: 500,
    color: '#ffffff',
    margin: 0,
    lineHeight: '120%',
  },
  featureDesc: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: 'rgba(255, 255, 255, 0.65)',
    lineHeight: '27px',
    fontWeight: 200,
    margin: 0,
  },
  mobileCarouselSection: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginTop: 0,
    },
  },
  mobileCardsTrack: {
    display: 'flex',
    gap: '16px',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    scrollPaddingLeft: '20px',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: 'touch',
    padding: '8px 16px 16px 16px',
    margin: '0 -20px',
    width: 'calc(100% + 40px)',
    boxSizing: 'border-box',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  mobileCard: {
    flex: '0 0 318px',
    width: 318,
    minWidth: 318,
    maxWidth: 318,
    height: 182,
    scrollSnapAlign: 'start',
    background:
      'linear-gradient(#131313, #131313) padding-box, linear-gradient(90deg, #87959c 1.44%, #89959c 7.69%, #8b949b 13.94%, #b1b3bb 21.15%, #c3c8cc 31.25%, #f1f2f4 38.94%, #d2dbe6 51.44%, #d2dbe6 63.46%, #9ab0b7 81.73%, #a5b7c0 94.71%) border-box',
    border: '0.5px solid transparent',
    borderRadius: 16,
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    boxSizing: 'border-box',
  },
  mobileCardIconBox: {
    width: 54,
    height: 54,
    minWidth: 54,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  mobileCardTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '100%',
    letterSpacing: '0%',
    textTransform: 'capitalize',
    color: '#ffffff',
    margin: '0 0 8px 0',
    textAlign: 'left',
  },
  mobileCardDesc: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 200,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: '#FFFFFF',
    textAlign: 'left',
    margin: 0,
  },
  dotsPagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginTop: '16px',
    marginBottom: '8px',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    outline: 'none',
  },
  activeDot: {
    backgroundColor: '#ffffff',
    width: 8,
    height: 8,
  },
}));

export const VirtualCompanionshipWhyMembersSection = () => {
  const classes = useStyles();
  const [activeDot, setActiveDot] = useState(0);
  const trackRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const scrollLeft = trackRef.current.scrollLeft;
    const cardWidth = 318 + 16;
    const index = Math.round(scrollLeft / cardWidth);
    setActiveDot(Math.min(Math.max(index, 0), FEATURES_DATA.length - 1));
  };

  const handleDotClick = (index: number) => {
    if (!trackRef.current) return;
    const cardWidth = 318 + 16;
    trackRef.current.scrollTo({
      left: index * cardWidth,
      behavior: 'smooth'
    });
    setActiveDot(index);
  };

  return (
    <Box className={classes.whyMembersOuter}>
      <Box className={classes.whyMembersSection}>
        {/* Mobile Header */}
        <Box className={classes.mobileHeader}>
          <Typography className={classes.whyTitle}>
            Why Choose SugarCribs
          </Typography>
          <Typography className={classes.whySubtitle}>
            Every interaction is built around trust, privacy, and quality — so connections feel real, not transactional.
          </Typography>
        </Box>

        {/* Left Column: Image */}
        <Box className={classes.whyImageContainer}>
          <img
            src={whyChooseImg}
            alt="Why Choose SugarCribs"
            className={classes.whyImage}
          />
        </Box>

        {/* Right Column: Content */}
        <Box className={classes.whyContent}>
          {/* Desktop Header */}
          <Box className={classes.desktopHeader}>
            <Typography className={classes.whyTitle}>
              Why Choose SugarCribs
            </Typography>
            <Typography className={classes.whySubtitle}>
              Every interaction is built around trust, privacy, and quality — so connections feel real, not transactional.
            </Typography>
          </Box>

          {/* Desktop Features List */}
          <Box className={classes.featuresList}>
            {FEATURES_DATA.map((feature, index) => (
              <Box key={index} className={classes.featureItem}>
                <Box className={classes.featureIconWrapper}>
                  {renderFeatureIcon(index, 'web')}
                </Box>
                <Box className={classes.featureTextContainer}>
                  <Typography className={classes.featureTitle}>
                    {feature.title}
                  </Typography>
                  <Typography className={classes.featureDesc}>
                    {feature.desc}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Mobile Horizontal Cards Carousel */}
          <Box className={classes.mobileCarouselSection}>
            <div
              className={classes.mobileCardsTrack}
              ref={trackRef}
              onScroll={handleScroll}
            >
              {FEATURES_DATA.map((feature, index) => (
                <div key={index} className={classes.mobileCard}>
                  <div className={classes.mobileCardIconBox}>
                    {renderFeatureIcon(index, 'mob')}
                  </div>
                  <Typography className={classes.mobileCardTitle}>
                    {feature.title}
                  </Typography>
                  <Typography className={classes.mobileCardDesc}>
                    {feature.desc}
                  </Typography>
                </div>
              ))}
            </div>

            <div className={classes.dotsPagination}>
              {FEATURES_DATA.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Go to slide ${index + 1}`}
                  className={`${classes.dot} ${activeDot === index ? classes.activeDot : ''}`}
                  onClick={() => handleDotClick(index)}
                />
              ))}
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
